<header class="vpn-header">
  <span class="vpn-header-icone">
    <mat-icon class="material-symbols-outlined">link</mat-icon>
  </span>
  <div class="vpn-header-texto">
    <h2 class="vpn-titulo">Vincular itens da NF-e ao pedido de compra</h2>
    <div class="vpn-subtitulo">@if (nota) { NF-e {{ numeroNota }} · }confirme a qual pedido e item cada linha da nota pertence</div>
  </div>
  <button mat-icon-button type="button" class="vpn-header-btn icon-mat-symbols-btn" (click)="alternarTamanho()"
    [matTooltip]="isMaximizado ? 'Restaurar' : 'Maximizar'" [attr.aria-label]="isMaximizado ? 'Restaurar' : 'Maximizar'">
    <mat-icon class="material-symbols-outlined">{{ isMaximizado ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
  </button>
  <button mat-icon-button type="button" class="vpn-header-btn icon-mat-symbols-btn" (click)="cancelar()" [disabled]="salvando"
    matTooltip="Fechar" aria-label="Fechar">
    <mat-icon class="material-symbols-outlined">close</mat-icon>
  </button>
</header>

@if (!carregando && nota) {
<div class="vpn-nota-wrap">
  <div class="vpn-nota">
    <div class="vpn-nota-id">
      <mat-icon class="material-symbols-outlined vpn-nota-icone">receipt_long</mat-icon>
      <div class="vpn-nota-id-texto">
        <div class="vpn-nota-numero">NF-e {{ numeroNota }}</div>
        <div class="vpn-nota-emitente">{{ nomeEmitente }}</div>
      </div>
    </div>

    <span class="status-badge badge-dot vpn-nota-status" [ngClass]="classeBadgeStatus(nota.idStatusNFeEntrada)">
      {{ rotuloStatus(nota.idStatusNFeEntrada) }}
    </span>

    <div class="vpn-nota-campo">
      <div class="vpn-nota-rotulo">Emissão</div>
      <div class="vpn-nota-valor">{{ (nota.dataEmissao | date: 'dd/MM/yyyy') || '—' }}</div>
    </div>

    <div class="vpn-nota-campo">
      <div class="vpn-nota-rotulo">Valor total</div>
      <div class="vpn-nota-valor vpn-nota-valor--forte">{{ valorTotalNota }}</div>
    </div>

    <div class="vpn-nota-campo vpn-nota-campo--chave">
      <div class="vpn-nota-rotulo">Chave de acesso</div>
      <div class="vpn-nota-chave">{{ nota.chaveAcesso || '—' }}</div>
    </div>

    <div class="vpn-chips">
      @for (chip of chips; track chip.chave) {
      <button type="button" class="vpn-chip" [class.vpn-chip--ativo]="filtro === chip.chave" (click)="filtrar(chip.chave)">
        {{ chip.rotulo }}
      </button>
      }
    </div>
  </div>
</div>
}

<mat-dialog-content class="vpn-conteudo">
  @if (carregando) {
  <div class="vpn-carregando">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
  </div>
  } @else {

  @if (itensVm.length === 0) {
  <div class="vpn-vazio">
    <mat-icon class="material-symbols-outlined">filter_alt_off</mat-icon>
    <div class="vpn-vazio-titulo">Nenhum item neste filtro</div>
    <div class="vpn-vazio-texto">Selecione outro filtro para ver os itens desta nota.</div>
  </div>
  }

  <div class="vpn-lista">
    @for (vm of itensVm; track vm.id) {
    <article class="vpn-item" [id]="vm.ancora" [class.vpn-item--vinculado]="vm.resolvido" [class.vpn-item--flash]="vm.flash">

      <div class="vpn-item-cabecalho">
        <mat-icon class="material-symbols-outlined vpn-item-icone">box</mat-icon>
        <span class="vpn-item-numero">ITEM #{{ vm.numero }}</span>
        @if (!vm.aberto) {
        <span class="vpn-item-sep">·</span>
        <span class="vpn-item-desc-curta" [matTooltip]="vm.descricao">{{ vm.descricao }}</span>
        @if (vm.vincResumo) {
        <span class="vpn-resumo-pill">
          <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>{{ vm.vincResumo }}
        </span>
        }
        }
        <span class="vpn-espaco"></span>
        <span class="status-badge vpn-item-status" [ngClass]="vm.resolvido ? 'badge-verde' : 'badge-amarelo'">
          <mat-icon class="material-symbols-outlined">{{ vm.resolvido ? 'check' : 'pending_actions' }}</mat-icon>
          {{ vm.resolvido ? 'Vinculado' : 'Pendente' }}
        </span>
        <button mat-icon-button type="button" class="vpn-item-toggle" (click)="alternarItem(vm.id)"
          matTooltip="Recolher/expandir item" aria-label="Recolher/expandir item">
          <mat-icon class="material-symbols-outlined">{{ vm.aberto ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>

      @if (vm.aberto) {
      <div class="vpn-item-corpo">

        <!-- Painel esquerdo: o item da nota e o que a associação (Central) gravou -->
        <div class="vpn-painel vpn-painel--nota">
          <div class="vpn-rotulo-secao">
            <mat-icon class="material-symbols-outlined">box</mat-icon>ITEM DA NOTA
          </div>
          <div class="vpn-nota-desc">{{ vm.descricao }}</div>
          @if (vm.metaXml) {
          <div class="vpn-meta">{{ vm.metaXml }}</div>
          }
          <span class="vpn-qtd-pill">
            {{ vm.qtdNf }}@if (vm.valorUnitario != null) { · {{ vm.valorUnitario | abnt: 'preco' }} }
          </span>

          @if (vm.assoc; as assoc) {
          <div class="vpn-assoc">
            <div class="vpn-rotulo-secao">
              <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>ASSOCIADO NO CADASTRO
            </div>
            <div class="vpn-assoc-produto">
              <span class="vpn-assoc-nome">{{ assoc.nome }}</span>
              @if (assoc.codigo) {
              <span class="vpn-assoc-codigo">{{ assoc.codigo }}</span>
              }
            </div>
            <div class="vpn-assoc-chips">
              @for (info of assoc.infos; track $index) {
              <span class="vpn-info-chip" [class.vpn-info-chip--destaque]="info.destaque"
                [matTooltip]="info.titulo" matTooltipClass="tooltip-multilinha">
                <mat-icon class="material-symbols-outlined">{{ info.icone }}</mat-icon>{{ info.texto }}
              </span>
              }
            </div>
          </div>
          }
        </div>

        <!-- Coluna central: confirmação do vínculo -->
        <div class="vpn-painel-acao">
          <span class="vpn-btn-vincular-tooltip" [matTooltip]="vm.motivoVincular ?? ''"
            [matTooltipDisabled]="!vm.motivoVincular || salvando">
            <button mat-flat-button type="button" class="btn-primary vpn-btn-vincular"
              [disabled]="vm.resolvido || !vm.podeConfirmar || salvando" (click)="confirmarItem(vm.id)">
              <mat-icon class="material-symbols-outlined">check</mat-icon>Vincular
            </button>
          </span>
        </div>

        <!-- Painel direito: pedido de origem -->
        <div class="vpn-painel vpn-painel--pedido">
          <div class="vpn-rotulo-secao">
            <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>PEDIDO DE ORIGEM
          </div>

          @if (vm.selecionando) {
          <div class="vpn-selecao">
            <div class="vpn-selecao-ajuda">
              Marque o item do pedido que esta linha da nota atende. Se a nota cobrir mais de um pedido, marque todos.
            </div>
            <mat-form-field appearance="outline" class="vpn-selecao-busca" subscriptSizing="dynamic">
              <input matInput placeholder="Nº do pedido, produto ou fornecedor…" [value]="vm.busca"
                (input)="pesquisarItensPedido(vm.id, $any($event.target).value)" />
              @if (vm.buscando) {
              <mat-progress-spinner matSuffix class="vpn-selecao-spinner" mode="indeterminate" diameter="18"></mat-progress-spinner>
              } @else {
              <mat-icon matSuffix class="material-symbols-outlined vpn-selecao-lupa">search</mat-icon>
              }
            </mat-form-field>

            <div class="vpn-candidatos">
              @for (c of vm.candidatos; track c.chave) {
              <div class="vpn-candidato" [class.vpn-candidato--marcado]="c.marcado"
                [class.vpn-candidato--bloqueado]="!c.elegivel">
                <mat-checkbox class="vpn-candidato-check" [checked]="c.marcado" [disabled]="!c.elegivel"
                  (change)="alternarCandidato(vm.id, c.chave)">
                  <span class="vpn-candidato-cabecalho">
                    <span class="vpn-candidato-pedido">{{ c.pedidoLabel }}</span>
                    <span class="vpn-candidato-fornecedor" [class.vpn-candidato-fornecedor--diferente]="c.fornecedorDiferente"
                      [class.vpn-candidato-fornecedor--vazio]="c.semFornecedor"
                      [matTooltip]="c.fornecedorDiferente ? 'Fornecedor diferente do emitente da nota' : 'Fornecedor do pedido'">
                      <mat-icon class="material-symbols-outlined">storefront</mat-icon>
                      <span class="vpn-candidato-fornecedor-nome">{{ c.fornecedorLabel }}</span>
                    </span>
                  </span>
                  <span class="vpn-candidato-item">
                    <span class="vpn-candidato-item-nome">{{ c.itemLabel }}</span>
                    <span class="vpn-candidato-qtd">{{ c.qtdLabel }}</span>
                  </span>
                  @if (c.elegivel) {
                  <span class="status-badge vpn-badge-compacto" [ngClass]="c.compatClasse">{{ c.compatLabel }}</span>
                  } @else {
                  <span class="vpn-candidato-motivo">
                    <mat-icon class="material-symbols-outlined">block</mat-icon>
                    <span>{{ c.motivoInelegivel }}</span>
                  </span>
                  }
                </mat-checkbox>
              </div>
              }
              @if (vm.candidatos.length === 0) {
              <div class="vpn-candidatos-vazio">Nenhum item de pedido corresponde à busca.</div>
              }
            </div>

            <div class="vpn-selecao-rodape">
              <span class="vpn-selecao-resumo">{{ vm.selResumo }}</span>
              <button mat-flat-button type="button" class="btn-primary vpn-btn-compacto" (click)="fecharSelecao(vm.id)">
                Concluir
              </button>
            </div>
          </div>
          } @else if (vm.vinculos.length) {

          @for (v of vm.vinculos; track v.chave) {
          <div class="vpn-vinculo">
            <div class="vpn-vinculo-icone">
              <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>
            </div>
            <div class="vpn-vinculo-corpo">
              <span class="vpn-vinculo-cabecalho">
                <span class="vpn-vinculo-pedido">{{ v.pedidoLabel }}</span>
                <span class="vpn-vinculo-fornecedor" [class.vpn-vinculo-fornecedor--diferente]="v.fornecedorDiferente"
                  [class.vpn-vinculo-fornecedor--vazio]="v.semFornecedor"
                  [matTooltip]="v.fornecedorDiferente ? 'Fornecedor diferente do emitente da nota' : 'Fornecedor do pedido'">
                  <mat-icon class="material-symbols-outlined">storefront</mat-icon>
                  <span class="vpn-vinculo-fornecedor-nome">{{ v.fornecedorLabel }}</span>
                </span>
                <span class="status-badge vpn-badge-compacto vpn-vinculo-origem" [ngClass]="vm.resolvido ? 'badge-verde' : v.sugerido ? 'badge-azul' : 'badge-cinza'"
                  [matTooltip]="v.origemTooltip ?? ''" [matTooltipDisabled]="!v.origemTooltip">
                  {{ v.origemLabel }}
                </span>
              </span>
              <span class="vpn-vinculo-item">{{ v.itemLabel }}</span>
              <div class="vpn-vinculo-linha">
                <span class="vpn-qtd-pill">
                  {{ v.qtdLabel }}@if (v.valorUnitario != null) { · {{ v.valorUnitario | abnt: 'preco' }} }
                </span>
              </div>
              @if (v.fornecedorDiferente) {
              <div class="vpn-vinculo-alerta-fornecedor">
                <mat-icon class="material-symbols-outlined">warning</mat-icon>
                <span>Pedido de outro fornecedor. A nota é de {{ nomeEmitente }}.</span>
              </div>
              }
              @if (v.alocEditavel) {
              <div class="vpn-aloc">
                <label class="vpn-aloc-rotulo" [for]="'vpn-aloc-' + vm.id + '-' + v.chave">{{ v.alocRotulo }}</label>
                <div class="vpn-aloc-linha">
                  <input class="vpn-aloc-input" [class.vpn-aloc-input--erro]="v.alocInvalida"
                    [id]="'vpn-aloc-' + vm.id + '-' + v.chave" type="text" inputmode="numeric" autocomplete="off"
                    [currencyMask]="quantidadeMask" [ngModel]="v.alocValor" [disabled]="salvando"
                    (ngModelChange)="alterarAlocacao(vm.id, v.chave, $event)" />
                  <button type="button" class="btn-link vpn-link" matTooltip="Relacionar o máximo possível deste item"
                    [disabled]="salvando" (click)="completarAlocacao(vm.id, v.chave)">Completar</button>
                </div>
                <span class="vpn-aloc-saldo">{{ v.alocSaldo }}</span>
              </div>
              }
            </div>
            <button mat-icon-button type="button" class="vpn-desvincular" matTooltip="Desvincular" aria-label="Desvincular"
              [disabled]="salvando" (click)="desvincular(vm.id, v.chave)">
              <mat-icon class="material-symbols-outlined">link_off</mat-icon>
            </button>
          </div>
          }

          @if (vm.confronto; as conf) {
          <div class="vpn-confronto" [ngClass]="'vpn-confronto--' + conf.estado">
            <mat-icon class="material-symbols-outlined vpn-confronto-icone">{{ conf.icone }}</mat-icon>
            <span class="vpn-confronto-texto">{{ conf.texto }}</span>
            <span class="status-badge vpn-badge-compacto" [ngClass]="conf.badgeClasse">{{ conf.badge }}</span>
          </div>
          }
          @if (vm.notaQuantidade) {
          <div class="vpn-nota-tolerancia">
            <mat-icon class="material-symbols-outlined">info</mat-icon>
            <span>{{ vm.notaQuantidade }}</span>
          </div>
          }

          @for (preco of vm.confrontosPreco; track $index) {
          <div class="vpn-confronto" [ngClass]="'vpn-confronto--' + preco.estado">
            <mat-icon class="material-symbols-outlined vpn-confronto-icone">{{ preco.icone }}</mat-icon>
            <span class="vpn-confronto-texto">{{ preco.texto }}</span>
            <span class="status-badge vpn-badge-compacto" [ngClass]="preco.badgeClasse">{{ preco.badge }}</span>
          </div>
          }
          @for (nota of vm.notasPreco; track $index) {
          <div class="vpn-nota-tolerancia">
            <mat-icon class="material-symbols-outlined">info</mat-icon>
            <span>{{ nota }}</span>
          </div>
          }

          <!-- Decisões fora da tolerância: pergunta curta + uma opção por cartão com o efeito escrito
               (mesmo desenho dos cartões de opção da configuração da etapa). A escolha fica marcada e pode ser trocada. -->
          @if (vm.decidirExcesso) {
          <div class="vpn-decisao">
            <div class="vpn-decisao-titulo">Como tratar a quantidade a mais?</div>
            <div class="vpn-decisao-opcoes">
              <button type="button" class="vpn-opcao" [class.vpn-opcao--ativa]="vm.escolhaExcesso === DecisaoQuantidade.AceitarAjustarSaldo"
                [disabled]="salvando" (click)="aceitarExcesso(vm.id)">
                <span class="vpn-opcao-icone"><mat-icon class="material-symbols-outlined">check</mat-icon></span>
                <span class="vpn-opcao-texto">
                  <strong>Aceitar e ajustar saldo</strong>
                  <small>O pedido passa a prever a quantidade da nota.</small>
                </span>
              </button>
              <button type="button" class="vpn-opcao" [class.vpn-opcao--ativa]="vm.escolhaExcesso === DecisaoQuantidade.MarcarDivergencia"
                [disabled]="salvando" (click)="marcarDivergencia(vm.id)">
                <span class="vpn-opcao-icone"><mat-icon class="material-symbols-outlined">report</mat-icon></span>
                <span class="vpn-opcao-texto">
                  <strong>Marcar divergência</strong>
                  <small>Vincula a nota e move o pedido para Divergência.</small>
                </span>
              </button>
            </div>
          </div>
          }

          @if (vm.decidirPreco) {
          <div class="vpn-decisao">
            <div class="vpn-decisao-titulo">Como tratar a diferença de preço?</div>
            <div class="vpn-decisao-opcoes">
              <button type="button" class="vpn-opcao" [class.vpn-opcao--ativa]="vm.escolhaPreco === DecisaoPreco.AceitarAjustarPreco"
                [disabled]="salvando" (click)="aceitarAjustePreco(vm.id)">
                <span class="vpn-opcao-icone"><mat-icon class="material-symbols-outlined">check</mat-icon></span>
                <span class="vpn-opcao-texto">
                  <strong>Aceitar e ajustar preço</strong>
                  <small>O pedido passa a usar o preço da nota.</small>
                </span>
              </button>
              <button type="button" class="vpn-opcao" [class.vpn-opcao--ativa]="vm.escolhaPreco === DecisaoPreco.MarcarDivergencia"
                [disabled]="salvando" (click)="marcarDivergenciaPreco(vm.id)">
                <span class="vpn-opcao-icone"><mat-icon class="material-symbols-outlined">report</mat-icon></span>
                <span class="vpn-opcao-texto">
                  <strong>Marcar divergência</strong>
                  <small>Vincula a nota e move o pedido para Divergência.</small>
                </span>
              </button>
            </div>
          </div>
          }

          @if (vm.decidirParcial) {
          <div class="vpn-acoes">
            <button mat-stroked-button type="button" class="btn-secondary vpn-btn-decisao vpn-btn-bloco" [disabled]="salvando"
              (click)="receberParcial(vm.id)">
              <mat-icon class="material-symbols-outlined">call_split</mat-icon>Receber parcial e dividir o saldo
            </button>
          </div>
          <app-alert-card type="info" class="vpn-alerta-decisao">
            O saldo não faturado vai para um novo pedido, na etapa de origem deste. Reversível enquanto os dois pedidos não avançarem.
          </app-alert-card>
          }

          <div>
            <button type="button" class="btn-link vpn-link" matTooltip="A nota pode atender mais de um item de pedido"
              [disabled]="salvando" (click)="abrirSelecao(vm.id)">
              <mat-icon class="material-symbols-outlined">edit</mat-icon>Alterar itens do pedido
            </button>
          </div>

          } @else {

          <div class="vpn-aviso">
            <mat-icon class="material-symbols-outlined">warning</mat-icon>
            <span class="status-badge badge-cinza vpn-badge-compacto">Sem sugestão</span>
            <span>{{ vm.semPedidoTexto }}</span>
          </div>
          <button mat-stroked-button type="button" class="btn-secondary vpn-btn-bloco" [disabled]="salvando"
            (click)="abrirSelecao(vm.id)">
            <mat-icon class="material-symbols-outlined">search</mat-icon>Escolher item do pedido
          </button>

          }
        </div>
      </div>
      }
    </article>
    }
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="vpn-rodape">
  <div class="vpn-progresso">
    <span class="vpn-progresso-rotulo">{{ totalVinculados }} de {{ totalItens }} vinculados</span>
    <div class="vpn-progresso-barra">
      <div class="vpn-progresso-valor" [style.width.%]="percentualVinculado"></div>
    </div>
  </div>
  <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()" [disabled]="salvando">Cancelar</button>
  <span [matTooltip]="motivoBloqueioConcluir" [matTooltipDisabled]="!motivoBloqueioConcluir">
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="salvando"
      [disabled]="!podeConcluir || salvando" [attr.aria-label]="salvando ? 'Vinculando' : 'Concluir associação e vincular'"
      (click)="concluir()">
      Concluir associação e vincular
      @if (salvando) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
  </span>
</mat-dialog-actions>
